export const linkHrefMap = {
    exhibitions: 'https://us.ecoflow.com/pages/ecoflow-exhibition-events',
    downloadPdf: `/download?url=${encodeURIComponent('https://websiteoss.ecoflow.com/pdf/BROCHURE-%202023%20Product%20Catalogue.pdf')}`,
};

export enum MODAL_TYPE {
    EMAIL,
    DETAIL,
    SUCCESS,
}
